import React from 'react'

export default function Docs() {
    return (
        <iframe
            frameborder="0" width="100%" height="600" allowFullScreen
            src="https://docs.ryzer.app/" />
    )
}
